import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const stats = [
  {
    icon: 'ri-time-line',
    value: '24/7',
    label: 'Поиск клиентов без выходных',
  },
  {
    icon: 'ri-flashlight-line',
    value: 'до 30с',
    label: 'Среднее время обнаружения запроса',
  },
  {
    icon: 'ri-broadcast-line',
    value: '200 000+',
    label: 'Telegram-чатов под мониторингом',
  },
  {
    icon: 'ri-shield-check-line',
    value: '0',
    label: 'Пропущенных заявок — всё фиксируется',
  },
];

export default function TLStats() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);

  return (
    <section className="bg-background-950 text-background-50 py-20 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-50"></div>
      <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-primary-500/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-400 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            В цифрах
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-background-50 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Что говорят цифры
          </h2>
          <p
            ref={descRef}
            className={`mt-4 text-[16px] text-background-50/60 reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
          >
            Прозрачные показатели работы системы.
          </p>
        </div>

        <div ref={cardsRef} className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {stats.map((stat, idx) => (
            <div
              key={stat.label}
              className={`group rounded-2xl border border-background-50/10 bg-background-50/[0.03] p-6 md:p-8 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-default reveal-fade-up ${idx < cardsRevealed ? 'revealed' : ''}`}
              style={idx < cardsRevealed ? { transitionDelay: `${idx * 100}ms` } : undefined}
            >
              <span className="w-10 h-10 rounded-lg bg-background-50/10 group-hover:bg-background-50/20 flex items-center justify-center text-primary-400 group-hover:text-background-50 transition-colors">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <div className="mt-6 font-display font-extrabold text-[36px] md:text-[44px] tracking-tightest leading-none text-background-50">
                {stat.value}
              </div>
              <p className="mt-3 text-[13.5px] md:text-[14px] text-background-50/60 group-hover:text-background-50/90 leading-snug transition-colors">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}